import React from 'react';
import { Button, Form, Select, Row, Col, DatePicker, Space } from 'antd';

const AppointmentForm = ({ selectedLanguage }) => {
    const services = [
        { label: selectedLanguage?.txt_fixing_implants, value: "Fixing Implants" },
        { label: selectedLanguage?.txt_crowns_and_bridge_repair, value: "Crowns & Bridge Repair" },
        { label: selectedLanguage?.txt_root_canal, value: "Root Canal" },
        { label: selectedLanguage?.txt_dental_filling_text, value: "Dental Filling" }
    ];

    const staffs = [
        { label: selectedLanguage?.txt_dr_hennah_krish, value: "Dr. Hennah Krish" },
        { label: selectedLanguage?.txt_dr_ankitha_prem, value: "Dr. Ankitha Prem" },
    ];

    const generateSpecificTimeOptions = () => {
        const options = [];
        for (let hour = 9; hour < 24; hour++) {
            const displayHour = hour > 12 ? hour - 12 : hour;
            const amPm = hour >= 12 ? 'PM' : 'AM';
            options.push({
                label: `${displayHour}:00 ${amPm}`,
                value: `${displayHour}:00 ${amPm}`
            });
        }
        options.push({
            label: `12:00 AM`,
            value: `12:00 AM`
        });
        return options;
    };

    const endTimeOptions = generateSpecificTimeOptions();

    const generateTimeOptions = () => {
        const options = [];
        for (let hour = 0; hour < 24; hour++) {
            const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
            const amPm = hour >= 12 ? 'PM' : 'AM';
            options.push({
                label: `${displayHour}:00 ${amPm}`,
                value: `${displayHour}:00 ${amPm}`
            });
        }
        return options;
    };

    const startTimeOptions = generateTimeOptions();

    const handleChange = (value) => {
        console.log(`Selected: ${value}`);
    };

    const onChange = (date, dateString) => {
        // console.log(date, dateString);
    };
    const onFinish = async (values) => {
        let formData = new FormData()
        console.log('formData', formData)
    }

    return (
        <Form
            className='appointment-form'
            name="basic"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete="off"
        >
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label={selectedLanguage?.txt_available_services}
                        name="services"
                    >
                        <Select
                            className='appointment-form-select'
                            allowClear
                            style={{ width: '100%' }}
                            placeholder={selectedLanguage?.txt_select}
                            onChange={handleChange}
                            options={services}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={selectedLanguage?.txt_staffs}
                        name="staffs"
                    >
                        <Select
                            className='appointment-form-select'
                            allowClear
                            style={{ width: '100%' }}
                            placeholder={selectedLanguage?.txt_select}
                            onChange={handleChange}
                            options={staffs}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <h2 className='time-heading'>{selectedLanguage?.txt_time}</h2>
            <div className='appointment-form-time-div'>
                <div className='appointment-date-div'>
                    <Form.Item
                        label={selectedLanguage?.txt_i_am_available_on}
                        name="date"
                    >
                        <Space direction="vertical" size={12}>
                            <DatePicker placeholder={selectedLanguage?.txt_select} className='appointment-form-select date-picker' onChange={onChange} needConfirm />
                        </Space>
                    </Form.Item>
                </div>
                <div className='appointment-time-div'>
                    <Form.Item
                        label={selectedLanguage?.txt_start}
                        name="startTime"
                    >
                        <Select
                            className='appointment-form-select'
                            allowClear
                            style={{ width: '100%' }}
                            placeholder={selectedLanguage?.txt_select}
                            onChange={handleChange}
                            options={startTimeOptions}
                            defaultValue={'8:00 AM'}
                        />
                    </Form.Item>
                </div>
                <div className='appointment-time-div'>
                    <Form.Item
                        label={selectedLanguage?.txt_end}
                        name="endTime"
                    >
                        <Select
                            className='appointment-form-select'
                            allowClear
                            style={{ width: '100%' }}
                            placeholder={selectedLanguage?.txt_select}
                            onChange={handleChange}
                            options={endTimeOptions}
                            defaultValue={'11:00 PM'}
                        />
                    </Form.Item>
                </div>
            </div>
            <div className='appointment-form-btn-div'>
                <Form.Item
                    wrapperCol={{ span: 24, offset: 0 }}
                >
                    <Button type="primary" htmlType="submit">
                        {selectedLanguage?.txt_show_time}
                    </Button>
                </Form.Item>
            </div>
        </Form>
    );
};

export default AppointmentForm;
